import { Nav, Tab } from "react-bootstrap";
import { IEdenMessageDetails } from "../../../api/IEdenMessage";
import { DocumentsGrid } from "../../../leap-components/Documents/DocumentsGrid";
import EpaCard from "../../../leap-components/EpaCard";

interface SubTabsProps {
  className?: string;
  activeKey: string;
  edenMessage: IEdenMessageDetails;
}

interface EdenMessageProps {
  edenMessage: IEdenMessageDetails;
}

const SubTabs = ({ className, activeKey, edenMessage }: SubTabsProps) => (
  <div className={"tab " + className}>
    <Tab.Container id="left-tabs-example" defaultActiveKey={activeKey}>
      <Nav variant="tabs">
        <Nav.Item>
          <Nav.Link eventKey="documents">Documents</Nav.Link>
        </Nav.Item>
      </Nav>
      <Tab.Content>
        <Tab.Pane eventKey="documents">
          <DocumentsGrid regardingObjectId={edenMessage.edenmessageid} />
        </Tab.Pane>
      </Tab.Content>
    </Tab.Container>
  </div>
);

const RelatedComplianceRecords = ({ edenMessage }: EdenMessageProps) => {
  var bodyElements = (
    <SubTabs activeKey="documents" edenMessage={edenMessage} />
  );

  return (
    <EpaCard title={"Related Compliance Records"} content={bodyElements} />
  );
};

export default RelatedComplianceRecords;
